<template>
    <div v-show="opened">

        <div class="wrapper">
            <button @click="toggleSearchPanel()" v-show="!searchPanelOpened" type="button" class="btn btn-confirm btn-xs btn-search">Szukaj</button>

            <div class="search" v-show="searchPanelOpened">
                <input v-on:keyup="search" v-model="selectedFilters.text" type="text" placeholder="Nazwa produktu" class="form-control" /> <br />

                <!--<select v-on:change="search" v-model="selectedFilters.category" class="form-control">-->
                    <!--<option v-for="category in categories" v-bind:value="category.id">{{ category.name }}</option>-->
                <!--</select>-->

                <br />

                <ul>
                    <li v-for="(text, key) in types">
                        <label><input @click="search" type="checkbox" v-model="selectedFilters.types" v-bind:value="key" /> {{ text }}</label>
                    </li>
                </ul>

                <div class="text-center">
                    <button @click="clearNotificationsFilter()" type="button" class="btn btn-cancel btn-xs">Zamknij</button>
                </div>
            </div>


            <div class="info" v-if="items.length > 0">
                Wyników {{ count }}, pokazane {{ items.length }}
                <br />
                Strona

                <span v-if="page > 0">
                    <a @click="changePage(false)" href="#">poprzednia</a>
                </span>

                {{ page+1 }}

                <span v-if="items.length > 0 && items.length == limit">
                    <a @click="changePage(true)" href="#">następna</a>
                </span>

            </div>

            <div class="loading" v-if="!loading && items.length == 0">Brak powiadomień</div>

            <div v-show="loading" class="text-center">
                <img src="../assets/img/loader.gif" />
            </div>

            <ul v-if="items.length > 0">
                <li v-for="notification in items">
                    <div class="well well-sm">
                        <a @click="showNotification(notification)" href="#" v-bind:title="notification.product_name + ' (' + notification.category_name + ')'" class="product-name">{{ notification.text }}</a>
                        <small v-if="types[notification.type]">{{ types[notification.type] }}</small>
                    </div>
                </li>
            </ul>
        </div>

        <div id="notification-modal" class="modal-mask" v-show="showModal">
            <div class="modal-wrapper">
                <div class="modal-container">
                    <div class="modal-body">
                        <notification :data="selectedNotification" :types="types"></notification>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-confirm btn-sm" @click="showModal = false">Zamknij</button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import Notification from './Notification.vue'

    export default {
        name: 'NotificationPanel',
        props: ['opened', 'existsNew'],
        components: {
            Notification
        },
        data() {
            return {
                categories: [],
                types: [],

                items: [],
                count: 0,
                limit: 100,
                page: 0,

                loading: false,
                showModal: false,

                selectedFilters: {
                    text: null,
                    category: null,
                    types: [],
                },

                selectedNotification: {},

                searchPanelOpened: false
            }
        },
        mounted() {
//             setTimeout(() => {
//                 this.init();
// //                this.load();
//             }, 100);
        },
        watch: {
             opened: {
                handler: function (newData, oldData) {
                    this.opened = newData

                    if (this.existsNew && this.opened) {
                        this.clearNotificationsFilter();
                        this.load();
                    }else if(this.opened && !this.searchPanelOpened && this.items.length === 0){
                        this.load();
                    }
                },
            }
        },
        methods: {
            init: function() {
                this.$http.get('notifications/init', {showProgressBar: false}).then((response) => {
                    this.categories = response.body.categories;
                    this.types = response.body.types;
                });
            },
            load: function(params) {
                this.loading = true;
                const v = this;
                params = params || {};

                params.read_new_notifications = this.existsNew;

                this.$http.get('notifications', {params: params}).then((response) => {
                    this.count = response.body.count;
                    this.limit = response.body.limit;
                    this.items = response.body.items;
                    this.page = response.body.page;

                    for (let i in this.items)
                    {
                        let maxLength = 25;
                        let item = this.items[i];
                        let text = item.product_name + ' (' + item.category_name + ')';

                        if (text.length > maxLength ) {
                            text = text.substring(0, maxLength ) + '...';
                        }

                        this.items[i].text = text;
                    }

                    this.loading = false;
                })
            },
            search: function(event) {

                if (event instanceof KeyboardEvent)
                {
                    if (event.location !== 0) {
                        return false;
                    }
                }

                this.load({
                    filter: this.selectedFilters
                });
            },
            toggleSearchPanel: function(){
                this.searchPanelOpened =  !this.searchPanelOpened;
            },
            clearNotificationsFilter() {
                this.selectedFilters.text = null;
                this.selectedFilters.category = null;
                this.selectedFilters.types = [];

                this.searchPanelOpened = false;

                this.load();
            },
            changePage(direction) {
                this.load({
                    'page': direction ? this.page + 1 : this.page - 1,
                    'filter': this.selectedFilters
                });
            },
            showNotification(notification) {
                this.showModal = true;
                this.selectedNotification = notification;
            },
        }
    }
</script>

<style>

</style>


// WEBPACK FOOTER //
// NotificationPanel.vue?ae2fb93e